// 文件废弃
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getDuration } from '@/biz/time';
import { isMobile, reviewTime } from '@/biz/tool';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import { UpgradeWarnIcon, CheckLinearIcon } from '../../common/icon';
import styles from './interestContent.module.less';
import { AdsPlatform } from '@/interface/order';
import PriceDetails from '@/components/web/components/PriceDetails';
import { AdsCampaignMarketingStrategy } from '@/interface/campaign';
import { NationsLab } from '@/utils/locations';
import { ProductType, ProductPhysicalSelectEnum } from '../config';
import { Alert, Select } from 'aha-components';
import { buildCountrySelectOptions, getCountryName } from '@/utils/locations';

interface Props {
  setShowAnInterestOpen?: Function;
  setSelectCountryError?: Function;
  selectCountryError?: boolean;
}

const initialScriptDraftDeadline = (hours: number | null) => {
  if (hours) return getDuration(hours);
  return '-';
};

const InterestContent: React.FC<Props> = ({
  setShowAnInterestOpen,
  setSelectCountryError,
  selectCountryError
}) => {
  const { t } = useTranslation();

  const { detailData } = useDetailDataStore();
  const { order, product, campaign } = detailData;
  const {
    setSkipScript,
    setAgreeProductShip,
    productShippingCountry,
    setProductShippingCountry
  } = useWebModalStore();

  const locations = detailData?.campaign?.locations || [];
  const countries = locations
    ?.map((item: string[]) => NationsLab?.[item?.[1]])
    ?.join(', ');

  const campaignCountries = locations
    ?.map((item: string[]) => item?.[1])
    ?.join(', ');

  const isProductShip =
    product?.productType === ProductType.PHYSICAL_PRODUCT &&
    product?.physicalProductShipType === ProductPhysicalSelectEnum.ship;
  useEffect(() => {
    if (
      !(
        detailData?.order?.marketingStrategy ===
          AdsCampaignMarketingStrategy.INFLUENCER_MARKETING &&
        order?.platform === AdsPlatform.Youtube &&
        !campaign?.isTrendCampaign
      )
    ) {
      setSkipScript(true);
    }
  }, [detailData, order, campaign?.isTrendCampaign]);

  return (
    <div>
      <div
        className={
          isMobile()
            ? styles.container
            : styles.webContainer + ' max-h-[calc(100vh-260px)] overflow-y-auto'
        }
      >
        {isProductShip && (
          <div className="mt-4 mb-2">
            <div className="text-base font-semibold leading-6 mb-2">
              {t('interest.shipping_country.title', {
                defaultValue: 'Product shipping country'
              })}
              <span className="text-red-500"> *</span>
            </div>
            <Select
              error={selectCountryError}
              showSearch
              value={productShippingCountry || undefined}
              onChange={(value) => {
                if (selectCountryError) {
                  setSelectCountryError?.(false);
                }
                const selected = (value as string) || '';
                setProductShippingCountry(selected);
                setAgreeProductShip(campaignCountries?.includes(value));
              }}
              options={buildCountrySelectOptions()}
              placeholder={t('interest.shipping_country.please_select', {
                defaultValue: 'Please select'
              })}
              // 因为移动端的层级是9999，所以需要设置一个更高的层级
              dropdownStyle={{ zIndex: 10000 }}
            />
            {selectCountryError ? (
              <div className="text-red-500 text-sm mt-2">
                {t('interest.shipping_country.please_select_country', {
                  defaultValue: 'This is a required field.'
                })}
              </div>
            ) : null}
            {productShippingCountry ? (
              campaignCountries?.includes(productShippingCountry) ? (
                <div className="flex items-center gap-2 mt-2 text-sm font-medium text-[#079455]">
                  <CheckLinearIcon className="w-6 h-6 text-[#079455]" />
                  {t('interest.shipping_country.description', {
                    defaultValue: 'Brand can ship to {{country}}',
                    country: getCountryName(productShippingCountry)
                  })}
                </div>
              ) : (
                <div className="bg-[#FEF2F2] leading-5 px-4 py-3 rounded-lg mt-2">
                  <div className="flex items-start gap-2">
                    <div className="mt-[2px]">
                      <UpgradeWarnIcon className="w-6 h-6" />
                    </div>
                    <div>
                      <div className="text-[#292524] text-base font-semibold">
                        {t('interest.shipping_country.cannot_ship_title', {
                          defaultValue: 'Brand cannot ship to {{country}}',
                          country: getCountryName(productShippingCountry)
                        })}
                      </div>
                      <div className="text-[#292524] text-sm font-normal mt-2">
                        {t(
                          'interest.shipping_country.cannot_ship_description',
                          {
                            defaultValue:
                              'This brand only ships to: {{countries}}. If you can receive products in any of these locations, please update your country selection.',
                            countries: countries
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )
            ) : null}
          </div>
        )}
        <PriceDetails
          isModal={true}
          order={order}
          product={product}
          isAcceptOffer={true}
        />
        <div
          className="h-[0] w-full bg-[#e8e8ec] mt-1 mb-1"
          style={{
            display: order?.platform === AdsPlatform.Youtube ? 'flex' : 'none'
          }}
        ></div>
      </div>
    </div>
  );
};

export default InterestContent;
